import $ from "jquery";
import { S3Upload } from "./s3";

class HotspotEditor {

    constructor() {
        this.isOpen = false
        this.bind()
    }

    centerActiveThumbnail() {
        const container = document.getElementById('hotspot-editor-thumbnails')
        const mainContainer = document.querySelector('.main-custom-split')
        if (!container) return

        // Find the active thumbnail by index
        const activeEl = container.querySelector(`.thumbnail[data-index="${this.currentFrame}"]`)
        if (!activeEl) return

        // Center the thumbnail in the visible container area
        const containerCenter = container.clientWidth / 2
        const activeCenter = activeEl.offsetLeft + (activeEl.offsetWidth / 2)

        // For the first thumbnail, we need to account for the padding
        // The first thumbnail should be centered in the visible area
        let targetScroll
        if (this.currentFrame === 0) {
            // For first thumbnail, scroll to position it at the center of visible area
            targetScroll = 0
        } else {
            // For other thumbnails, center normally but reduce by 72px
            targetScroll = activeCenter - containerCenter - 72
        }

        container.scrollTo({ left: targetScroll, behavior: 'smooth' })
    }

    centerClickedThumbnail(clickedEl) {
        const container = document.getElementById('hotspot-editor-thumbnails')
        const mainContainer = document.querySelector('.main-custom-split')
        if (!container || !clickedEl) return

        // Get the index of the clicked thumbnail
        const clickedIndex = parseInt(clickedEl.getAttribute('data-index'))

        // Center the clicked thumbnail in the visible container area
        const containerCenter = container.clientWidth / 2
        const clickedCenter = clickedEl.offsetLeft + (clickedEl.offsetWidth / 2)

        // For the first thumbnail, we need to account for the padding
        let targetScroll
        if (clickedIndex === 0) {
            // For first thumbnail, scroll to position it at the center of visible area
            targetScroll = 0
        } else {
            // For other thumbnails, center normally but reduce by 72px
            targetScroll = clickedCenter - containerCenter - 72
        }

        container.scrollTo({ left: targetScroll, behavior: 'smooth' })
    }

    setupThumbnailPadding() {
        const container = document.getElementById('hotspot-editor-thumbnails')
        if (!container) return

        // Wait for container to have proper dimensions
        if (container.clientWidth === 0) {
            setTimeout(() => this.setupThumbnailPadding(), 50)
            return
        }

        //

        // Calculate padding based on the thumbnail container width
        const containerWidth = container.clientWidth
        const thumbnailWidth = 60 // matches CSS width
        const gap = 5 // matches CSS gap between thumbnails

        // Calculate padding to center the first thumbnail
        // We need enough padding so that when the first thumbnail is centered,
        // it appears in the middle of the visible area, with no extra scrollable space
        const padding = (containerWidth / 2) - (thumbnailWidth / 2)

        // Apply padding to allow centering of first/last items
        container.style.paddingLeft = `${padding}px`
        container.style.paddingRight = `${padding}px`


    }

    reset() {
        this.uuid = null
        this.pk = null
        this.hotspots = []
        this.thumbnails = []
        this.images = []

        this.width = 0
        this.height = 0

        this.currentHotspot = null
        this.currentFrame = 0
        this.rotateFrame = 0
        this.lastFrame = null
        this.lastRoute = ''
        this.lastWindow = null

        this.mouseDown = null
        this.mouseX = null
        this.mouseY = null
        this.mouseMode = null
        this.mouseThumbnail = null

        this.renderTimeout = null
    }

    bind() {
        let that = this

        $(window).on('resize', function () {
            that.calcDimensions()
            that.setupThumbnailPadding()
            that.lastFrame = null
        })

        // Initialize hotspot editor when page loads (Hotspots loads via full page navigation)
        const initHotspotEditor = () => {
            setTimeout(function () {
                if ($('#hotspot-editor').length > 0 && !that.isOpen) {
                    let variantUuid = window.location.pathname.match(/\/products\/([^\/]+)/)?.[1]
                    let variantPk = $('#hotspot-editor').data('variant-pk')
                    if (variantUuid && variantPk) {
                        that.initializeEditor(variantPk, variantUuid)
                    }
                }
            }, 100)
        }
        $(document).ready(initHotspotEditor)
        $(document).on('turbo:load', initHotspotEditor)

        $(document).on('click', '#hotspot-editor-close', function () {
            that.saveHotspots(function () {
                that.closeEditor()
            })
        })

        $(document).on('click', '#hotspot-editor-cancel', function () {
            that.closeEditor()
        })

        $(document).on('click', '#hotspot-editor-create', function (e) {
            e.preventDefault()
            that.createHotspot()
        })

        // Save changes button
        $(document).on('click', '#hotspot-editor-save', function () {
            that.saveHotspots(function () {
                // After saving, refresh thumbnail indicators
                that.updateThumbnailIndicators()
            })
        })

        $(document).on('click', '.hotspot-editor-update', function () {
            let pk = $(this).data('hotspot')
            that.updateHotspot(pk)
        })

        $(document).on('click', '#hotspot-editor-tabs .tab', function () {
            let rel = $(this).attr('rel')
            that.openForm(rel)
        })

        $(document).on('click', '#hotspot-editor-clear', function () {
            that.clearHotspotPositions()
        })

        $(document).on('click', '.hotspot-editor-delete', function (e) {
            let id = $(this).data('hotspot')
            that.deleteHotspotConfirm(id)
        })

        $(document).on('click', '#hotspot-editor-delete-confirm', function (e) {
            that.deleteHotspot()
        })

        $(document).on('change', '#hotspot-editor-delete-confirm-ask', function (e) {
            let checked = $(this).prop('checked')
            if (checked) {
                localStorage.setItem('hotspot-editor-delete-confirm-ask', 'no')
            } else {
                localStorage.setItem('hotspot-editor-delete-confirm-ask', 'yes')
            }
        })

        $(document).on('mousedown', '#hotspot-editor-thumbnails div.thumbnail', function (e) {
            that.mouseThumbnail = parseInt($(this).data('index'))
            that.mouseMode = 'thumbnail'
            that.handleMouseDown(e)

            if (that.currentHotspot === null) {
                return
            }

            if ($(this).hasClass('window-first')) {
                that.mouseMode = 'window-first'
            } else if ($(this).hasClass('window-last')) {
                that.mouseMode = 'window-last'
            }
        })

        $(document).on('mouseenter', '#hotspot-editor-thumbnails div.thumbnail', function (e) {
            if (that.currentHotspot === null) {
                return
            }

            let frame = parseInt($(this).data('index'))

            if (that.mouseMode === 'window-first') {
                that.currentHotspot.window[0] = frame
                that.currentHotspot.updateWindow()
            } else if (that.mouseMode === 'window-last') {
                that.currentHotspot.window[1] = frame
                that.currentHotspot.updateWindow()
            }
        })

        $(document).on('mouseup', '#hotspot-editor-thumbnails div.thumbnail', function (e) {
            if (Date.now() - that.mouseDown < 200 && that.mouseThumbnail !== null) {
                that.currentFrame = that.mouseThumbnail
            }
            that.handleMouseUp(e)
        })

        $(document).on('mousedown', '.hotspot-spot', function (e) {
            // Get the hotspot ID from the spot element
            let hotspotId = $(this).attr('id').replace('hotspot-', '');

            // If this hotspot is not currently selected, select it first
            if (that.currentHotspot === null || that.currentHotspot.data.id != hotspotId) {
                that.selectHotspotForEditing(hotspotId);
            }

            // Check if position tab is active in the accordion
            const positionTab = $(`.hotspot-action-tab[data-action="position"][data-hotspot="${hotspotId}"]`)
            const isPositionTabActive = positionTab.hasClass('active')

            if (isPositionTabActive && that.currentHotspot !== null) {
                that.mouseMode = 'spot'
                that.currentForm = 'hotspot-editor-position' // Set the form for hotspot moving
                // Initialize drag state so click won't open popup while dragging
                if (that.currentHotspot) {
                    that.currentHotspot.mouseDrag = false
                }
            }
        })

        $(document).on('click', '#hotspot-editor-thumbnails div.waypoint .path', function (e) {
            e.stopPropagation()
            let index = parseInt($(this).closest('.thumbnail').data('index'))
            that.currentHotspot.removePoint(index)
            // Re-render thumbnail badges after removing a point
            that.updateThumbnailIndicators()
        })

        $(document).on('input', '.hotspot-editor-field', function () {
            let name = $(this).attr('name')
            let value = $(this).val()
            that.updateHotspotField($(this), name, value)
        })

        $(document).on('mousedown', '#hotspot-editor-preview canvas', function (e) {
            that.handleMouseDown(e)
            if (that.mouseMode === null) {
                that.mouseMode = 'canvas'
            }
        })

        $(document).on('mouseup', function (e) {
            that.handleMouseUp(e)
        })

        $(document).on('mousemove', function (e) {
            that.handleMouseMove(e)
        })

        addEventListener("trix-change", function (event) {
            that.updateHotspotField('text', 'text', event.target.value)
        })
    }

    handleMouseDown(e) {
        this.mouseDown = Date.now()
        this.mouseX = e.pageX
        this.mouseY = e.pageY
    }

    handleMouseUp(e) {
        if (this.mouseMode === 'canvas') {
            // Do not set or move hotspots by clicking the canvas
        } else if (this.mouseMode === 'spot') {
            this.currentHotspot.setPoint(this.currentFrame, e.pageX, e.pageY, true)
            // Refresh thumbnail badges after dropping a dragged point
            this.updateThumbnailIndicators()
            // Keep drag flag true through click event, then reset shortly after
            const draggedHotspot = this.currentHotspot
            if (draggedHotspot) {
                setTimeout(() => { draggedHotspot.mouseDrag = false }, 100)
            }
        }

        this.mouseMode = null
        this.mouseDown = 0
        this.mouseX = 0
        this.mouseY = 0
        this.mouseThumbnail = null
    }

    handleMouseMove(e) {
        if (this.mouseMode === 'canvas') {
            let dx = 0

            if (this.tiltRotationAxis) {
                dx = e.pageY - this.mouseY
            } else {
                dx = e.pageX - this.mouseX
            }
            // rotate the viewer
            let distance = dx / 8
            if (this.reverseSpin) {
                distance = -distance
            }
            this.rotateFrame -= distance

            if (this.rotateFrame < -0.4) {
                this.rotateFrame = this.images.length - 1
            }
            if (this.rotateFrame > this.images.length - 0.6) {
                this.rotateFrame = -0.4
            }

            this.currentFrame = Math.round(this.rotateFrame)
        } else if (this.mouseMode === 'spot') {
            this.currentHotspot.setPoint(this.currentFrame, e.pageX, e.pageY, false)
        }

        this.mouseX = e.pageX
        this.mouseY = e.pageY
    }

    initializeEditor(pk, uuid) {
        this.isOpen = true
        this.reset()

        this.pk = pk
        this.uuid = uuid
        let that = this
        this.thumbnails = []
        this.images = []

        // The HTML is already loaded in the frame, just initialize the editor
        that.canvas = document.getElementById('hotspot-editor-canvas')
        let settings = $('#hotspot-settings')
        that.domain = settings.data('domain')
        that.bucket = settings.data('bucket')
        that.srcWidth = parseInt(settings.data('width'))
        that.srcHeight = parseInt(settings.data('height'))
        that.reverseSpin = (settings.data('reverse-spin') === true)
        that.tiltRotationAxis = (settings.data('tilt-rotation-axis') === true)
        that.imageRevision = settings.attr('data-image-revision')

        that.calcDimensions()

        $('.hotspot-editor-image').each(function () {
            let src = $(this).data('src')
            let url = that.buildSource(src, 1600, 1600)
            let img = new Image()
            img.src = url
            that.images.push(img)
        })

        // No cloning needed - we'll show only the actual frames

        // Initialize all thumbnails with proper indices and event handlers
        $('#hotspot-editor-thumbnails .thumbnail').each(function (index) {
            let src = $(this).data('src')
            let url = that.buildSource(src, 160, 160)
            $(this).css({ backgroundImage: `url(${url})` })

            // Use the actual index (no wrapping needed since we removed cloning)
            $(this).attr('data-index', index)

            // Add click handler to change current frame and center the clicked thumbnail
            $(this).on('click', function () {
                let frameIndex = parseInt($(this).data('index'))
                that.currentFrame = frameIndex
                that.rotateFrame = frameIndex
                that.centerClickedThumbnail(this)
            })

            // Simple hover effect - just highlight the thumbnail
            $(this).on('mouseenter', function () {
                let frameIndex = parseInt($(this).data('index'));
                $(this).addClass('hovered');
            })

            $(this).on('mouseleave', function () {
                let frameIndex = parseInt($(this).data('index'));
                $(this).removeClass('hovered');
            })

            that.thumbnails.push($(this))
        })

        // Set up padding for proper centering (with delay to ensure container is sized)
        setTimeout(() => {
            this.setupThumbnailPadding()
        }, 100)

        // Initialize HTML5 color pickers for hotspots
        $('#hotspot-color-picker').on('change', function () {
            const color = this.value;
            $('#hotspot-color').val(color).trigger('change');
        });

        $('#hotspot-content-background-picker').on('change', function () {
            const color = this.value;
            // Ensure color has # prefix for text field
            const hexColor = color.startsWith('#') ? color : '#' + color;
            $('#hotspot-content-background').val(hexColor).trigger('change');
        });

        $('#hotspot-content-foreground-picker').on('change', function () {
            const color = this.value;
            // Ensure color has # prefix for text field
            const hexColor = color.startsWith('#') ? color : '#' + color;
            $('#hotspot-content-foreground').val(hexColor).trigger('change');
        });

        // Sync text fields with color pickers
        $('#hotspot-color').on('input', function () {
            const color = this.value;
            // Check if it's a valid hex color (with or without #)
            if (color && /^#?[a-fA-F0-9]{6}$/.test(color)) {
                // Ensure it has # prefix for color picker
                const hexColor = color.startsWith('#') ? color : '#' + color;
                $('#hotspot-color-picker').val(hexColor);
            }
        });

        $('#hotspot-content-background').on('input', function () {
            const color = this.value;
            // Check if it's a valid hex color (with or without #)
            if (color && /^#?[a-fA-F0-9]{6}$/.test(color)) {
                // Ensure it has # prefix for color picker
                const hexColor = color.startsWith('#') ? color : '#' + color;
                $('#hotspot-content-background-picker').val(hexColor);
            }
        });

        $('#hotspot-content-foreground').on('input', function () {
            const color = this.value;
            // Check if it's a valid hex color (with or without #)
            if (color && /^#?[a-fA-F0-9]{6}$/.test(color)) {
                // Ensure it has # prefix for color picker
                const hexColor = color.startsWith('#') ? color : '#' + color;
                $('#hotspot-content-foreground-picker').val(hexColor);
            }
        });

        that.refreshHotspotList()

        // Show the editor immediately when loaded in a Turbo frame
        $('#hotspot-editor').show()

        // Show the thumbnails
        $('#hotspot-editor-thumbnails').show()
        that.centerActiveThumbnail()
        that.updateThumbnailIndicators()

        // Ensure the forms are disabled initially (no hotspot selected)
        $('#hotspot-editor-tabs').addClass('disabled')
        $('#hotspot-editor-forms').addClass('disabled')



        // start rendering
        that.render()
    }


    calcDimensions() {
        if (!this.canvas) {
            return
        }

        let aspectRatio = this.srcWidth / this.srcHeight
        // Keep room for the thumbnail bar (approx 110px incl. margins)
        let maxWidth = $(window).width() * 0.7
        let reservedForThumbnailsPx = 110
        let reservedForPaddingPx = 40
        let maxHeight = $(window).height() - reservedForThumbnailsPx - reservedForPaddingPx
        if (maxHeight < 200) {
            maxHeight = 200
        }

        let height = maxHeight
        let width = maxHeight * aspectRatio
        if (width > maxWidth) {
            width = maxWidth
            height = maxWidth / aspectRatio
        }

        this.width = Math.round(width)
        this.height = Math.round(height)

        this.canvas.setAttribute('width', this.width)
        this.canvas.setAttribute('height', this.height)
    }

    closeEditor() {
        this.isOpen = false

        if (this.renderTimeout) {
            clearTimeout(this.renderTimeout)
        }

        $('iframe').each(function () {
            $(this).attr('src', $(this).attr('src'))
        })

        $('#hotspot-editor').fadeOut(function () {
            $('#hotspot-editor').remove()
        })
    }

    buildSource(src, width, height) {
        // Use the same URL format as the regular image_link helper
        // Format: https://media-domain/payer-uuid/image-path/resize;w_width;h_height/optimize;bg_ffffff/image.jpg

        // Extract the payer UUID from the bucket (which should be the payer's public UUID)
        let payerUuid = this.bucket;

        // Construct the URL using the same format as image_link helper
        let transformations = [];

        if (width) {
            transformations.push(`w_${width}`);
        }
        if (height) {
            transformations.push(`h_${height}`);
        }

        let resizeParams = transformations.join(';');
        let url = `https://${this.domain}/${payerUuid}/${src}/resize;${resizeParams}/optimize;bg_ffffff/image.jpg`;

        return url;
    }

    updateHotspot(pk) {

        for (let hotspot of this.hotspots) {
            if (hotspot.data.id == pk) { // Use == for type coercion
                this.currentHotspot = hotspot
                hotspot.isVisible = true
                hotspot.isActive = true

                // Populate form fields within the accordion
                this.populateAccordionForm(hotspot.data)
            } else {
                hotspot.isVisible = false
                hotspot.isActive = false
            }
        }

    }

    populateAccordionForm(data) {
        // Populate all form fields within the accordion for this hotspot
        // Only populate fields that exist (since we're using dynamic tab content)

        // Content tab fields
        if ($(`#hotspot-title-${data.id}`).length) {
            $(`#hotspot-title-${data.id}`).val(data.title ? data.title.replace(/^>\s*/, '') : '')
        }
        if ($(`#hotspot-content-mode-${data.id}`).length) {
            $(`#hotspot-content-mode-${data.id}`).val(data.content_mode || 'default')
        }
        if ($(`#hotspot-text-${data.id}`).length) {
            $(`#hotspot-text-${data.id}`).val(data.text || '')
        }
        // Update rich text editor content
        if ($(`#rich-editor-text-${data.id}`).length) {
            $(`#rich-editor-text-${data.id}`).html(data.text || '')
        }
        if ($(`#hotspot-video-${data.id}`).length) {
            $(`#hotspot-video-${data.id}`).val(data.video || '')
        }

        // Design tab fields
        if ($(`#hotspot-color-${data.id}`).length) {
            $(`#hotspot-color-${data.id}`).val(data.color || '#ffff00')
        }
        if ($(`#hotspot-color-picker-${data.id}`).length) {
            $(`#hotspot-color-picker-${data.id}`).val(data.color || '#ffff00')
        }
        if ($(`#hotspot-shadow-${data.id}`).length) {
            $(`#hotspot-shadow-${data.id}`).prop('checked', data.shadow || false)
        }
        if ($(`#hotspot-content-position-${data.id}`).length) {
            $(`#hotspot-content-position-${data.id}`).val(data.content_position || 'tl')
        }
        if ($(`#hotspot-content-opacity-${data.id}`).length) {
            $(`#hotspot-content-opacity-${data.id}`).val(data.content_opacity || 100)
        }
        if ($(`#hotspot-content-background-${data.id}`).length) {
            $(`#hotspot-content-background-${data.id}`).val(data.content_background || '#ffffff')
        }
        if ($(`#hotspot-content-background-picker-${data.id}`).length) {
            $(`#hotspot-content-background-picker-${data.id}`).val(data.content_background || '#ffffff')
        }
        if ($(`#hotspot-content-foreground-${data.id}`).length) {
            $(`#hotspot-content-foreground-${data.id}`).val(data.content_foreground || '#000000')
        }
        if ($(`#hotspot-content-foreground-picker-${data.id}`).length) {
            $(`#hotspot-content-foreground-picker-${data.id}`).val(data.content_foreground || '#000000')
        }
        if ($(`#hotspot-font-family-${data.id}`).length) {
            $(`#hotspot-font-family-${data.id}`).val(data.font_family || 'Arial')
        }

        // Update image display
        if ($(`#hotspot-image-current-${data.id} span`).length) {
            if (data.image_url) {
                $(`#hotspot-image-current-${data.id} span`).text(data.image_url)
            } else {
                $(`#hotspot-image-current-${data.id} span`).text('None')
            }
        }

        // Show/hide appropriate editors based on content mode
        if ($(`#rich-editor-wrapper-${data.id}`).length && $(`#custom-editor-wrapper-${data.id}`).length) {
            if (data.content_mode === 'custom') {
                $(`#rich-editor-wrapper-${data.id}`).hide()
                $(`#custom-editor-wrapper-${data.id}`).show()
                if ($(`#custom-editor-text-${data.id}`).length) {
                    $(`#custom-editor-text-${data.id}`).val(data.text || '')
                }
            } else {
                $(`#rich-editor-wrapper-${data.id}`).show()
                $(`#custom-editor-wrapper-${data.id}`).hide()
            }
        }
    }

    selectHotspotForEditing(pk) {

        // Select hotspot for editing without hiding other hotspots
        for (let hotspot of this.hotspots) {
            if (hotspot.data.id == pk) { // Use == for type coercion
                this.currentHotspot = hotspot
                // Only mark as active (position/editing) when in position form
                const isPositionForm = (this.currentForm === 'hotspot-editor-position')
                hotspot.isActive = !!isPositionForm
                // Keep all hotspots visible
                hotspot.isVisible = true
            } else {
                // Don't change visibility, just deactivate
                hotspot.isActive = false
            }
        }

        $('.hotspot-editor-update').removeClass('active')
        $(`.hotspot-editor-update[data-hotspot=${pk}]`).addClass('active')

        // Ensure position tab is active in the accordion
        const accordionId = `hotspot-accordion-${pk}`
        const positionTab = $(`#${accordionId}`).closest('.customize-section-wrapper').find('.hotspot-action-tab[data-action="position"]')
        if (positionTab.length > 0) {
            positionTab.addClass('active')
            // Remove active class from other tabs
            $(`#${accordionId}`).closest('.customize-section-wrapper').find('.hotspot-action-tab').not(positionTab).removeClass('active')
        }

        if (this.currentForm) {
            this.openForm(this.currentForm)
        } else {
            this.openForm('hotspot-editor-position')
        }
    }

    closeForm() {
        this.currentHotspot = null
        $('.hotspot-sub-item').removeClass('active')
        $('#hotspot-editor-tabs').addClass('disabled')
        $('#hotspot-editor-forms').addClass('disabled')
        for (let hotspot of this.hotspots) {
            hotspot.isVisible = true
            hotspot.isActive = false
        }
    }

    openForm(name) {

        if (this.currentHotspot === null) {
            return
        }

        $('#hotspot-editor-tabs').removeClass('disabled')
        $('#hotspot-editor-forms').removeClass('disabled')

        $('#hotspot-editor-tabs a').removeClass('active')
        $(`[rel=${name}]`).addClass('active')

        $('.hotspot-editor-form').hide()
        $(`#${name}`).fadeIn()

        this.currentForm = name

        // Don't set isActive to false here - let the specific form logic handle it
        $('#hotspot-editor-preview').attr('data-form', name)

        if (name === 'hotspot-editor-design') {
            if (this.currentHotspot) { this.currentHotspot.isActive = false; this.currentHotspot.mouseDrag = false }
            $('#hotspot-color').val(this.currentHotspot.data.color)
            $('#hotspot-color-picker').val(this.currentHotspot.data.color)

            $('#hotspot-shadow').prop('checked', this.currentHotspot.data.shadow)

            $('#hotspot-content-opacity').val(this.currentHotspot.data.content_opacity)

            let background = this.currentHotspot.data.content_background || '#fff'
            $('#hotspot-content-background').val(background)
            $('#hotspot-content-background-picker').val(background)

            let foreground = this.currentHotspot.data.content_foreground || '#333'
            $('#hotspot-content-foreground').val(foreground)
            $('#hotspot-content-foreground-picker').val(foreground)

            let fontFamily = this.currentHotspot.data.font_family
            if (fontFamily) {
                $('#hotspot-font-family').val(fontFamily)
            }

            $('#hotspot-content-position').val(this.currentHotspot.data.content_position)

        } else if (name === 'hotspot-editor-position') {
            this.currentHotspot.isActive = true
            // If hotspot has no path data, give it an initial position in the center
            if (this.currentHotspot.path.length === 0) {
                let centerX = $('#hotspot-editor-preview').width() / 2
                let centerY = $('#hotspot-editor-preview').height() / 2
                this.currentHotspot.setPoint(this.currentFrame, centerX, centerY, true)
            }
            // Force a render to show the hotspot
            this.currentHotspot.render(this.currentFrame)
            // Do not show hotspot content in position mode

            // Coordinates readout removed per request
        } else if (name === 'hotspot-editor-content') {
            if (this.currentHotspot) { this.currentHotspot.isActive = false; this.currentHotspot.mouseDrag = false }
            // init form fields
            $('#hotspot-title').val(this.currentHotspot.data.title ? this.currentHotspot.data.title.replace(/^>\s*/, '') : '')
            let contentMode = this.currentHotspot.data.content_mode || 'default'
            $('#hotspot-content-mode').val(contentMode)
            $('#hotspot-text').val(this.currentHotspot.data.text)

            if (contentMode === 'custom') {
                $('#custom-editor-text').val(this.currentHotspot.data.text)
                $('#custom-editor-wrapper').show();
                $('#rich-editor-wrapper').hide();
            } else {
                $('#custom-editor-wrapper').hide();
                $('#rich-editor-wrapper').show();

                if (this.currentHotspot.data.image) {
                    $('#hotspot-image-current span').text(this.currentHotspot.data.image).show()
                    $('#hotspot-image-current').show()
                } else {
                    $('#hotspot-image-current span').text('')
                    $('#hotspot-image-current').hide()
                }
                $('#hotspot-video').val(this.currentHotspot.data.video)

                let editor = document.querySelector("#trix-editor-text").editor
                editor.loadHTML(this.currentHotspot.data.text)
            }
        } else {
            // Any other tab (e.g., delete): disable position editing state
            if (this.currentHotspot) { this.currentHotspot.isActive = false; this.currentHotspot.mouseDrag = false }
        }
    }

    clearHotspotPositions() {
        if (this.currentHotspot === null) {
            return
        }

        this.currentHotspot.clearPath()
    }


    updateHotspotField(fld, name, value) {
        if (this.currentHotspot === null) {
            return
        }
        //console.log(name, value)

        if (name === 'image') {
            let file = $('#hotspot-image').prop('files')[0]
            this.imageUpload(file)
        } else {
            if (this.currentHotspot.data[name] === value) {
                return
            }

            if (name === 'title') {
                $('.hotspot-editor-update.active').text(value)
            } else if (name === 'video') {
                value = value.replace('https://www.youtube.com/watch?v=', 'https://www.youtube.com/embed/')
                value = value.replace('https://vimeo.com/', 'https://player.vimeo.com/video/')
                fld.val(value)
            } else if (name === 'shadow') {
                value = $('#hotspot-shadow').prop('checked')
            }

            this.currentHotspot.data[name] = value
            this.currentHotspot.buildHTML()

            if (name === 'content_mode') {
                this.openForm('hotspot-editor-content')
            }
        }
    }


    /*
    * VIEWER EVENTS
     */
    render() {
        if (this.currentFrame < this.images.length) {
            let context = this.canvas.getContext('2d')
            context.clearRect(0, 0, this.width, this.height)
            context.drawImage(this.images[this.currentFrame], 0, 0, this.width, this.height)

            for (let hotspot of this.hotspots) {
                hotspot.render(this.currentFrame)
            }
            this.thumbnailScroll()
            this.visualizeSpots()
            this.visualizeWindow()

            this.lastFrame = this.currentFrame
        }

        let that = this

        this.renderTimeout = window.setTimeout(function () {
            that.render()
        }, 100)
    }

    thumbnailScroll() {
        // check if correctly initialized
        if (this.currentFrame === null || this.currentFrame >= this.images.length) {
            return
        }

        // return if nothing changed
        if (this.lastFrame === this.currentFrame) {
            return
        }

        // Remove active class from previous frame
        if (this.lastFrame !== null) {
            this.thumbnails[this.lastFrame]?.removeClass('active')
        }

        // Add active class to current frame
        this.thumbnails[this.currentFrame]?.addClass('active')

        // Keep the active thumbnail centered horizontally
        this.centerActiveThumbnail()
    }

    visualizeSpots() {
        // draw markers on thumbnails to show if the image is part of the route for a hotspot
        if (this.currentHotspot === null || this.currentForm !== 'hotspot-editor-position') {
            if (this.lastRoute != null) {
                this.lastRoute = null
                $('#hotspot-editor-thumbnails div.thumbnail').removeClass('waypoint')
            }
            return
        }

        let route = this.currentHotspot.route
        if (route.join('|') === this.lastRoute) {
            return
        }

        this.lastRoute = route.join('|')

        for (let i = 0; i < this.thumbnails.length; i++) {
            if (route.indexOf(i) >= 0) {
                this.thumbnails[i].addClass('waypoint')
            } else {
                this.thumbnails[i].removeClass('waypoint')
            }
        }
    }

    visualizeWindow() {
        if (this.currentHotspot === null || this.currentForm !== 'hotspot-editor-position' || this.currentHotspot.window.length === 0) {
            if (this.lastWindow != null) {
                this.lastWindow = null
                $('#hotspot-editor-thumbnails div.thumbnail').removeClass('window')
                $('#hotspot-editor-thumbnails div.thumbnail').removeClass('window-first')
                $('#hotspot-editor-thumbnails div.thumbnail').removeClass('window-last')
                $('#hotspot-editor-thumbnails div.thumbnail').removeClass('window-start')
                $('#hotspot-editor-thumbnails div.thumbnail').removeClass('window-end')
            }
            return
        }

        let window = this.currentHotspot.window
        if (window.join('|') === this.lastWindow) {
            return
        }

        this.lastWindow = window.join('|')
        let windowFrames = this.currentHotspot.windowFrames

        for (let i = 0; i < this.thumbnails.length; i++) {
            this.thumbnails[i].removeClass('window')
            this.thumbnails[i].removeClass('window-first')
            this.thumbnails[i].removeClass('window-last')
            this.thumbnails[i].removeClass('window-start')
            this.thumbnails[i].removeClass('window-end')

            if (windowFrames[0] === i) {
                this.thumbnails[i].addClass('window-first')
                this.thumbnails[i].addClass('window-start')
            } else if (windowFrames[windowFrames.length - 1] === i) {
                this.thumbnails[i].addClass('window-last')
                this.thumbnails[i].addClass('window-end')
            }

            if (windowFrames.indexOf(i) > -1) {
                this.thumbnails[i].addClass('window')
            }
        }
    }

    initializeHotspotAccordion(accordionId) {
        // Find the accordion elements
        const header = document.querySelector(`[data-bs-target="#${accordionId}"]`)
        const chevron = header ? header.querySelector('.chevron-toggle') : null
        const collapse = document.getElementById(accordionId)
        const sectionHeader = header ? header.closest('.customize-section-header') : null
        const sectionWrapper = header ? header.closest('.customize-section-wrapper') : null

        if (!header || !chevron || !collapse || !sectionHeader || !sectionWrapper) return

        // Initial state
        if (collapse.classList.contains('show')) {
            chevron.classList.add('chevron-rotated')
            sectionHeader.classList.add('active')
        } else {
            chevron.classList.remove('chevron-rotated')
            sectionHeader.classList.remove('active')
        }

        // Listen for collapse events
        // Use jQuery for Bootstrap collapse events
        $(collapse).on('show.bs.collapse', function () {
            chevron.classList.add('chevron-rotated')
            sectionHeader.classList.add('active')
            // Add class to show tab icons when accordion is open
            sectionWrapper.classList.add('accordion-open')
        })

        // Use jQuery for Bootstrap collapse events
        $(collapse).on('hide.bs.collapse', function () {
            chevron.classList.remove('chevron-rotated')
            sectionHeader.classList.remove('active')
            // Remove class to hide tab icons when accordion is closed
            sectionWrapper.classList.remove('accordion-open')
            // Remove active state from all tab icons when accordion is closed
            sectionWrapper.querySelectorAll('.hotspot-action-tab').forEach(tab => {
                tab.classList.remove('active')
            })
        })
    }

    showPositionContentInAccordion(accordionId, hotspotId) {
        // Remove any existing position content
        $(`#${accordionId} .position-content-section`).remove()

        // Create position content section
        const positionContentHtml = `
            <div class="position-content-section">
                <div class="hotspot-form-section">
                    <h6 class="hotspot-form-section-title">
                        <i class="bi bi-geo-alt me-2"></i>Position Instructions
                    </h6>
                    <div class="mb-3">
                        <p><strong>Instructions:</strong></p>
                        <ul>
                            <li>Click the point on the photo where you want to add the hotspot.</li>
                            <li>For each hotspot, place at least three points; to do so, rotate the image and click where you want to add the spot.</li>
                            <li>Below, the image thumbnails with the hotspot added will be highlighted in blue.</li>
                            <li>Drag the handle on the side of the blue highlight to add the hotspot to additional images.</li>
                            <li>You can adjust the location of the hotspot in any image by selecting the thumbnail and dragging the hotspot.</li>
                            <li>The hotspot location will be automatically updated in surrounding photos.</li>
                        </ul>
                    </div>
                    <button class="btn btn-warning btn-sm hotspot-clear-btn" data-hotspot="${hotspotId}">Clear spots</button>
                </div>
            </div>
        `

        // Add position content at the beginning of the accordion content
        $(`#${accordionId} .hotspot-accordion-content`).prepend(positionContentHtml)

        // Add event handler for clear spots button
        $(`#${accordionId} .hotspot-clear-btn`).on('click', function () {
            const hotspotId = $(this).data('hotspot')
            if (this.currentHotspot && this.currentHotspot.data.id == hotspotId) {
                this.currentHotspot.clearPath()
            }
            // Remove the position content section after clearing
            $(`#${accordionId} .position-content-section`).remove()
        }.bind(this))
    }

    showTabContent(accordionId, hotspotId, action) {
        // Clear existing content
        $(`#${accordionId} .hotspot-accordion-content`).empty()

        let contentHtml = ''

        if (action === 'position') {
            contentHtml = this.getPositionTabContent(hotspotId)
        } else if (action === 'content') {
            contentHtml = this.getContentTabContent(hotspotId)
        } else if (action === 'design') {
            contentHtml = this.getDesignTabContent(hotspotId)
        } else if (action === 'delete') {
            contentHtml = this.getDeleteTabContent(hotspotId)
        }

        // Add content to accordion
        $(`#${accordionId} .hotspot-accordion-content`).html(contentHtml)

        // Coordinates readout removed per request

        // Add event handlers for the new content
        this.addTabEventHandlers(accordionId, hotspotId, action)

        // Initialize rich text editor if this is content tab
        if (action === 'content') {
            this.initializeRichTextEditor(hotspotId)
        }
    }

    getPositionTabContent(hotspotId) {
        return `
            <div class="hotspot-form-section">
                <h6 class="hotspot-form-section-title">
                    <i class="bi bi-geo-alt me-2"></i>Position Instructions
                </h6>
                <div class="mb-3">
                    <p><strong>Instructions:</strong></p>
                    <ul>
                        <li>Click the point on the photo where you want to add the hotspot.</li>
                        <li>For each hotspot, place at least three points; to do so, rotate the image and click where you want to add the spot.</li>
                        <li>Below, the image thumbnails with the hotspot added will be highlighted in blue.</li>
                        <li>Drag the handle on the side of the blue highlight to add the hotspot to additional images.</li>
                        <li>You can adjust the location of the hotspot in any image by selecting the thumbnail and dragging the hotspot.</li>
                        <li>The hotspot location will be automatically updated in surrounding photos.</li>
                    </ul>
                </div>
                <button class="btn btn-warning btn-sm hotspot-clear-btn" data-hotspot="${hotspotId}">Clear spots</button>
            </div>
        `
    }

    getContentTabContent(hotspotId) {
        return `
            <div class="hotspot-form-section">
                <h6 class="hotspot-form-section-title">
                    <i class="bi bi-file-text me-2"></i>Content Settings
                </h6>
                <div class="mb-3">
                    <label for="hotspot-title-${hotspotId}">Title</label>
                    <input type="text" name="title" id="hotspot-title-${hotspotId}" class="form-control hotspot-editor-field" data-hotspot="${hotspotId}">
                    <div class="form-text">A title describing this hotspot.</div>
                </div>
                <div class="mb-3">
                    <label>Content Mode</label>
                    <select name="content_mode" id="hotspot-content-mode-${hotspotId}" class="form-control hotspot-editor-field" data-hotspot="${hotspotId}">
                        <option value="default">Default</option>
                        <option value="custom">Custom</option>
                    </select>
                </div>
                <div class="mb-3">
                    <label>Text</label>
                    <input id="hotspot-text-${hotspotId}" type="hidden" name="text" class="hotspot-editor-field" data-hotspot="${hotspotId}">
                    <div id="rich-editor-wrapper-${hotspotId}">
                        <div class="rich-text-toolbar">
                            <button type="button" class="toolbar-button" data-command="bold" title="Bold">
                                <i class="bi bi-type-bold"></i>
                            </button>
                            <button type="button" class="toolbar-button" data-command="italic" title="Italic">
                                <i class="bi bi-type-italic"></i>
                            </button>
                            <button type="button" class="toolbar-button" data-command="underline" title="Underline">
                                <i class="bi bi-type-underline"></i>
                            </button>
                            <button type="button" class="toolbar-button" data-command="createLink" title="Link">
                                <i class="bi bi-link-45deg"></i>
                            </button>
                            <button type="button" class="toolbar-button" data-command="insertUnorderedList" title="Bullet List">
                                <i class="bi bi-list-ul"></i>
                            </button>
                            <button type="button" class="toolbar-button" data-command="insertOrderedList" title="Numbered List">
                                <i class="bi bi-list-ol"></i>
                            </button>
                            <button type="button" class="toolbar-button" data-command="undo" title="Undo">
                                <i class="bi bi-arrow-counterclockwise"></i>
                            </button>
                            <button type="button" class="toolbar-button" data-command="redo" title="Redo">
                                <i class="bi bi-arrow-clockwise"></i>
                            </button>
                        </div>
                        <div class="rich-text-editor" id="rich-editor-text-${hotspotId}" contenteditable="true" data-hotspot="${hotspotId}" placeholder="Enter your content here..."></div>
                        <div class="form-text">An optional text box which will appear when clicking the hotspot.</div>
                    </div>
                    <div id="custom-editor-wrapper-${hotspotId}" style="display: none;">
                        <div class="small">You may add custom HTML/CSS to this field. You are responsible for entering only valid HTML.</div>
                        <textarea id="custom-editor-text-${hotspotId}" class="hotspot-editor-field" name="text" data-hotspot="${hotspotId}"></textarea>
                    </div>
                </div>
                <div class="mb-3">
                    <label>Image</label>
                    <input type="file" name="image" id="hotspot-image-${hotspotId}" class="form-control hotspot-editor-field" data-hotspot="${hotspotId}">
                    <div id="hotspot-image-current-${hotspotId}">Currently: <span></span></div>
                    <div class="form-text">An image to display inside the text box.</div>
                </div>
                <div class="mb-3">
                    <label for="hotspot-video-${hotspotId}">Video</label>
                    <input type="text" name="video" id="hotspot-video-${hotspotId}" class="form-control hotspot-editor-field" data-hotspot="${hotspotId}">
                    <div class="form-text">You may add a youtube video to the text box. Paste the video id into this field.</div>
                </div>
            </div>
        `
    }

    getDesignTabContent(hotspotId) {
        return `
            <div class="hotspot-form-section">
                <h6 class="hotspot-form-section-title">
                    <i class="bi bi-palette me-2"></i>Design Settings
                </h6>
                <div class="mb-3">
                    <label>Spot Color</label>
                    <div class="row">
                        <div class="col-4">
                            <input type="color" id="hotspot-color-picker-${hotspotId}" value="#ffff00" class="form-control form-control-color" data-hotspot="${hotspotId}">
                        </div>
                        <div class="col-8">
                            <input type="text" name="color" id="hotspot-color-${hotspotId}" class="form-control hotspot-editor-field" value="#ffff00" data-hotspot="${hotspotId}">
                        </div>
                    </div>
                </div>
                <div class="mb-3">
                    <label>
                        <input type="checkbox" name="shadow" id="hotspot-shadow-${hotspotId}" class="hotspot-editor-field" data-hotspot="${hotspotId}">
                        Spot Shadow
                    </label>
                </div>
                <div class="mb-3">
                    <label>Content Position</label>
                    <select name="content_position" id="hotspot-content-position-${hotspotId}" class="form-control hotspot-editor-field" data-hotspot="${hotspotId}">
                        <option value="tl">top left</option>
                        <option value="tr">top right</option>
                        <option value="br">bottom right</option>
                        <option value="bl">bottom left</option>
                    </select>
                </div>
                <div class="mb-3">
                    <label>Content Opacity</label>
                    <input type="range" name="content_opacity" id="hotspot-content-opacity-${hotspotId}" class="form-range hotspot-editor-field" min="0" max="100" value="100" data-hotspot="${hotspotId}">
                    <div class="form-text">Adjust the opacity of the content background.</div>
                </div>
                <div class="mb-3">
                    <label>Content Background</label>
                    <div class="row">
                        <div class="col-4">
                            <input type="color" id="hotspot-content-background-picker-${hotspotId}" value="#ffffff" class="form-control form-control-color" data-hotspot="${hotspotId}">
                        </div>
                        <div class="col-8">
                            <input type="text" name="content_background" id="hotspot-content-background-${hotspotId}" class="form-control hotspot-editor-field" value="#ffffff" data-hotspot="${hotspotId}">
                        </div>
                    </div>
                </div>
                <div class="mb-3">
                    <label>Content Foreground</label>
                    <div class="row">
                        <div class="col-4">
                            <input type="color" id="hotspot-content-foreground-picker-${hotspotId}" value="#000000" class="form-control form-control-color" data-hotspot="${hotspotId}">
                        </div>
                        <div class="col-8">
                            <input type="text" name="content_foreground" id="hotspot-content-foreground-${hotspotId}" class="form-control hotspot-editor-field" value="#000000" data-hotspot="${hotspotId}">
                        </div>
                    </div>
                </div>
                <div class="mb-3">
                    <label>Font Family</label>
                    <select name="font_family" id="hotspot-font-family-${hotspotId}" class="form-control hotspot-editor-field" data-hotspot="${hotspotId}">
                        <option>Arial</option>
                        <option>Helvetica</option>
                        <option>Times New Roman</option>
                        <option>Trebuchet MS</option>
                        <option>Verdana</option>
                    </select>
                </div>
            </div>
        `
    }

    getDeleteTabContent(hotspotId) {
        return `
            <div class="hotspot-form-section">
                <h6 class="hotspot-form-section-title">
                    <i class="bi bi-trash me-2"></i>Delete Hotspot
                </h6>
                <div class="mb-3">
                    <div class="alert alert-warning">
                        <strong>Warning:</strong> This action cannot be undone. Deleting this hotspot will permanently remove it from all frames.
                    </div>
                    <p>Are you sure you want to delete this hotspot?</p>
                </div>
                <div class="d-flex gap-2">
                    <button class="btn btn-danger btn-sm hotspot-delete-confirm-btn" data-hotspot="${hotspotId}">Yes, Delete Hotspot</button>
                    <button class="btn btn-secondary btn-sm hotspot-cancel-delete-btn">Cancel</button>
                </div>
            </div>
        `
    }

    initializeRichTextEditor(hotspotId) {
        const editor = document.getElementById(`rich-editor-text-${hotspotId}`)
        const hiddenInput = document.getElementById(`hotspot-text-${hotspotId}`)
        const toolbar = editor?.parentElement?.querySelector('.rich-text-toolbar')

        if (!editor || !toolbar) return

        // Handle toolbar button clicks
        toolbar.addEventListener('click', (e) => {
            const button = e.target.closest('.toolbar-button')
            if (!button) return

            e.preventDefault()
            const command = button.dataset.command
            const value = button.dataset.value

            // Focus the editor first
            editor.focus()

            // Execute the command
            if (command === 'createLink') {
                const url = prompt('Enter URL:')
                if (url) {
                    document.execCommand(command, false, url)
                }
            } else if (value) {
                document.execCommand(command, false, value)
            } else {
                document.execCommand(command, false, null)
            }

            // Update button states
            this.updateToolbarButtons(toolbar, editor)

            // Update hidden input and propagate change to data model
            this.updateHiddenInput(editor, hiddenInput)
            if (hiddenInput) {
                $(hiddenInput).trigger('change')
            }
        })

        // Handle editor content changes
        editor.addEventListener('input', () => {
            this.updateHiddenInput(editor, hiddenInput)
            if (hiddenInput) {
                // Ensure we pass the jQuery element to updateHotspotField via delegated handler
                $(hiddenInput).trigger('input')
                $(hiddenInput).trigger('change')
            }
        })

        // Handle selection changes to update button states
        editor.addEventListener('selectionchange', () => {
            this.updateToolbarButtons(toolbar, editor)
        })

        // Handle focus events to style the toolbar
        editor.addEventListener('focus', () => {
            toolbar.classList.add('focused')
        })

        editor.addEventListener('blur', () => {
            toolbar.classList.remove('focused')
        })

        // Handle toolbar button focus
        toolbar.addEventListener('focusin', () => {
            toolbar.classList.add('focused')
        })

        toolbar.addEventListener('focusout', () => {
            // Only remove focused class if no element in toolbar has focus
            setTimeout(() => {
                if (!toolbar.contains(document.activeElement)) {
                    toolbar.classList.remove('focused')
                }
            }, 0)
        })

        // Handle paste events to clean up content
        editor.addEventListener('paste', (e) => {
            e.preventDefault()
            const text = (e.clipboardData || window.clipboardData).getData('text/plain')
            document.execCommand('insertText', false, text)
        })
    }

    updateToolbarButtons(toolbar, editor) {
        const buttons = toolbar.querySelectorAll('.toolbar-button')

        buttons.forEach(button => {
            const command = button.dataset.command

            if (command === 'bold' || command === 'italic' || command === 'underline') {
                button.classList.toggle('active', document.queryCommandState(command))
            } else if (command === 'insertUnorderedList' || command === 'insertOrderedList') {
                button.classList.toggle('active', document.queryCommandState(command))
            }
        })
    }

    updateHiddenInput(editor, hiddenInput) {
        if (hiddenInput) {
            hiddenInput.value = editor.innerHTML
        }
    }

    // Helpers to show coordinates as read-only values in the Position tab
    // coordinates readout helpers removed

    addTabEventHandlers(accordionId, hotspotId, action) {
        if (action === 'position') {
            // Add event handler for clear spots button
            $(`#${accordionId} .hotspot-clear-btn`).on('click', function () {
                if (this.currentHotspot && this.currentHotspot.data.id == hotspotId) {
                    this.currentHotspot.clearPath()
                }
            }.bind(this))
        } else if (action === 'content') {
            // Populate form fields with current hotspot data
            if (this.currentHotspot && this.currentHotspot.data.id == hotspotId) {
                this.populateAccordionForm(this.currentHotspot.data)
            }

            // Add event handlers for content mode change
            $(`#${accordionId} #hotspot-content-mode-${hotspotId}`).on('change', function () {
                const mode = $(this).val()
                if (mode === 'custom') {
                    $(`#rich-editor-wrapper-${hotspotId}`).hide()
                    $(`#custom-editor-wrapper-${hotspotId}`).show()
                } else {
                    $(`#rich-editor-wrapper-${hotspotId}`).show()
                    $(`#custom-editor-wrapper-${hotspotId}`).hide()
                }
            })
        } else if (action === 'design') {
            // Populate form fields with current hotspot data
            if (this.currentHotspot && this.currentHotspot.data.id == hotspotId) {
                this.populateAccordionForm(this.currentHotspot.data)
            }
        } else if (action === 'delete') {
            // Add event handlers for delete buttons
            $(`#${accordionId} .hotspot-delete-confirm-btn`).on('click', function () {
                this.deleteHotspotConfirm(hotspotId)
            }.bind(this))

            $(`#${accordionId} .hotspot-cancel-delete-btn`).on('click', function () {
                // Switch back to position tab
                $(`#${accordionId}`).closest('.customize-section-wrapper').find('.hotspot-action-tab').removeClass('active')
                $(`#${accordionId}`).closest('.customize-section-wrapper').find('.hotspot-action-tab[data-action="position"]').addClass('active')
                this.showTabContent(accordionId, hotspotId, 'position')
            }.bind(this))
        }

        // Add common event handlers for form fields
        $(`#${accordionId} .hotspot-editor-field`).on('change input', function () {
            const fieldName = $(this).attr('name')
            const fieldValue = $(this).val()

            if (this.currentHotspot && this.currentHotspot.data.id == hotspotId) {
                this.updateHotspotField($(this), fieldName, fieldValue)
            }
        }.bind(this))

        // Add event handlers for color pickers
        $(`#${accordionId} .form-control-color`).on('change', function () {
            const color = $(this).val()
            const targetField = $(this).attr('id').replace('-picker', '')

            $(`#${targetField}`).val(color).trigger('change')
        })
    }

    updateThumbnailIndicators() {
        // Clear existing indicators
        $('.thumbnail-indicator').remove()

        // Count hotspots per frame
        let frameHotspotCount = {}

        // Initialize all frames with 0 hotspots
        for (let i = 0; i < this.images.length; i++) {
            frameHotspotCount[i] = 0
        }

        // Count hotspots for each frame
        for (let hotspot of this.hotspots) {
            // Get frames where this hotspot is visible
            let visibleFrames = new Set()

            // Add frames from route (path waypoints)
            if (hotspot.route && hotspot.route.length > 0) {
                hotspot.route.forEach(frame => visibleFrames.add(frame))
            }

            // Add frames from window
            if (hotspot.windowFrames && hotspot.windowFrames.length > 0) {
                hotspot.windowFrames.forEach(frame => visibleFrames.add(frame))
            }

            // Increment count for each visible frame
            visibleFrames.forEach(frame => {
                if (frameHotspotCount.hasOwnProperty(frame)) {
                    frameHotspotCount[frame]++
                }
            })
        }

        // Add indicators to thumbnails that have hotspots
        for (let frameIndex in frameHotspotCount) {
            if (frameHotspotCount[frameIndex] > 0) {
                let thumbnail = $(`.thumbnail[data-index="${frameIndex}"]`)
                if (thumbnail.length > 0) {
                    // Create indicator element
                    let indicator = $('<div class="thumbnail-indicator"></div>')
                    indicator.text(frameHotspotCount[frameIndex])
                    thumbnail.append(indicator)
                }
            }
        }
    }

    /** API CALLS **/
    refreshHotspotList() {
        // download list of hot spots and refresh the hotspot list
        this.closeForm()

        let that = this
        let url = `/products/${this.uuid}/hotspots.json`
        $.ajax({
            url: url,
            method: 'GET',
            data: { variant: this.variant },
            success: (data) => {
                // remove html elements
                for (let hotspot of that.hotspots) {
                    hotspot.remove()
                }
                that.hotspots = []
                $('#hotspot-editor-existing').html('')

                for (let item of data) {
                    that.addHotspot(item)
                }

                // Update thumbnail indicators after all hotspots are loaded
                that.updateThumbnailIndicators()
            }
        })
    }

    addHotspot(item) {
        item.frames = this.images.length
        let hotspot = new HotspotPreview(item)
        this.hotspots.push(hotspot)

        // Create hotspot accordion item
        let hotspotNumber = this.hotspots.length
        let accordionId = `hotspot-accordion-${item.id}`

        let accordionHtml = `
            <div class="customize-section-wrapper">
                <div class="customize-section-header">
                    <div data-bs-toggle="collapse" data-bs-target="#${accordionId}">
                        ${item.title ? item.title.replace(/^>\s*/, '') : ''}
                    </div>
                    <div class="hotspot-actions">
                        <i class="bi bi-geo-alt hotspot-action-tab" data-action="position" data-hotspot="${item.id}" title="Position instructions"></i>
                        <i class="bi bi-file-text hotspot-action-tab" data-action="content" data-hotspot="${item.id}" title="Content settings"></i>
                        <i class="bi bi-palette hotspot-action-tab" data-action="design" data-hotspot="${item.id}" title="Design settings"></i>
                        <i class="bi bi-trash hotspot-action-tab" data-action="delete" data-hotspot="${item.id}" title="Delete hotspot"></i>
                    </div>
                </div>
                <div id="${accordionId}" class="collapse" data-bs-parent="#hotspot-editor-existing">
                    <div class="hotspot-accordion-content">
                        <!-- Tab content will be dynamically loaded here -->
                    </div>
                </div>
            </div>
        `

        $('#hotspot-editor-existing').append(accordionHtml)

        // Initialize chevron rotation and active states for the new accordion item
        this.initializeHotspotAccordion(accordionId)

        // Simplified accordion state management
        const wrapper = $(`#${accordionId}`).closest('.customize-section-wrapper')
        const collapse = wrapper.find('.collapse')

        // Handle accordion state changes
        const handleAccordionStateChange = (isOpen) => {
            if (isOpen) {
                // Determine which tab should be active
                let activeTab = wrapper.find('.hotspot-action-tab.active')

                // Clear all active states in all accordions
                $('.customize-section-wrapper .hotspot-action-tab').removeClass('active')

                // If no active tab, default to position
                if (activeTab.length === 0) {
                    activeTab = wrapper.find('.hotspot-action-tab[data-action="position"]')
                }

                // Activate the tab and load its content
                activeTab.addClass('active')
                const action = activeTab.data('action')
                that.showTabContent(accordionId, item.id, action)

                // When switching to position, ensure editor state reflects it
                if (action === 'position') {
                    // Set current hotspot and form to position mode
                    that.updateHotspot(item.id)
                    that.currentForm = 'hotspot-editor-position'
                    $('#hotspot-editor-preview').attr('data-form', 'hotspot-editor-position')

                    // Ensure the hotspot is visible/rendered
                    if (that.currentHotspot) {
                        that.currentHotspot.isActive = true
                        // If no path yet, initialize a center point
                        if (that.currentHotspot.path.length === 0) {
                            let centerX = $('#hotspot-editor-preview').width() / 2
                            let centerY = $('#hotspot-editor-preview').height() / 2
                            that.currentHotspot.setPoint(that.currentFrame, centerX, centerY, true)
                        }
                        that.currentHotspot.render(that.currentFrame)
                    }
                }
            } else {
                wrapper.find('.hotspot-action-tab').removeClass('active')
            }
        }

        // Use MutationObserver as the single source of truth for state changes
        const observer = new MutationObserver(function (mutations) {
            mutations.forEach(function (mutation) {
                if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
                    const target = mutation.target
                    const isOpen = target.classList.contains('show') && !target.classList.contains('collapsing')
                    const isClosed = !target.classList.contains('show') && !target.classList.contains('collapsing')

                    if (isOpen) {
                        handleAccordionStateChange(true)
                    } else if (isClosed) {
                        handleAccordionStateChange(false)
                    }
                }
            })
        })

        observer.observe(collapse[0], { attributes: true, attributeFilter: ['class'] })

        // Add event handlers for tab icons
        let that = this; // Store reference to 'this' for use in event handler
        $(`#${accordionId}`).closest('.customize-section-wrapper').find('.hotspot-action-tab').on('click', function (e) {
            e.stopPropagation() // Prevent accordion toggle
            let action = $(this).data('action')
            let hotspotId = $(this).data('hotspot')


            // Update hotspot for editing
            that.updateHotspot(hotspotId)

            // Close other accordions first (accordion behavior)
            $('#hotspot-editor-existing .collapse.show').each(function () {
                if (this.id !== `hotspot-accordion-${hotspotId}`) {
                    // Remove active state from all tab icons in this accordion
                    const accordionWrapper = $(this).closest('.customize-section-wrapper')
                    accordionWrapper.find('.hotspot-action-tab').removeClass('active')

                    if (typeof bootstrap !== 'undefined' && bootstrap.Collapse) {
                        const bsCollapse = bootstrap.Collapse.getInstance(this)
                        if (bsCollapse) {
                            bsCollapse.hide()
                        }
                    } else {
                        $(this).removeClass('show')
                    }
                }
            })

            // Expand the accordion if not already open
            const accordionId = `hotspot-accordion-${hotspotId}`
            const collapse = $(`#${accordionId}`)
            if (collapse.length > 0 && !collapse.hasClass('show')) {
                // Use Bootstrap's collapse method if available, otherwise use jQuery
                if (typeof bootstrap !== 'undefined' && bootstrap.Collapse) {
                    new bootstrap.Collapse(collapse[0], { show: true })
                } else {
                    collapse.addClass('show')
                }
            }

            // Update active tab
            $(`#${accordionId}`).closest('.customize-section-wrapper').find('.hotspot-action-tab').removeClass('active')
            $(this).addClass('active')

            // Show appropriate tab content
            that.showTabContent(accordionId, hotspotId, action)
        })

        // Add event handlers for form fields within the accordion
        $(`#${accordionId} .hotspot-editor-field`).on('change input', function () {
            let hotspotId = $(this).data('hotspot')
            let fieldName = $(this).attr('name')
            let fieldValue = $(this).val()


            // Update the hotspot data
            if (hotspotId && that.currentHotspot && that.currentHotspot.data.id == hotspotId) {
                that.updateHotspotField(fieldName, fieldName, fieldValue)
            }
        })

        // Add event handler for clear spots button
        $(`#${accordionId} .hotspot-clear-btn`).on('click', function () {
            let hotspotId = $(this).data('hotspot')

            if (that.currentHotspot && that.currentHotspot.data.id == hotspotId) {
                that.currentHotspot.clearPath()
            }
        })

        // Add event handlers for color pickers
        $(`#${accordionId} .form-control-color`).on('change', function () {
            let hotspotId = $(this).data('hotspot')
            let color = $(this).val()
            let targetField = $(this).attr('id').replace('-picker', '')


            // Update the corresponding text field
            $(`#${targetField}`).val(color).trigger('change')
        })

        // Add event handler for content mode change
        $(`#${accordionId} #hotspot-content-mode-${item.id}`).on('change', function () {
            let hotspotId = $(this).data('hotspot')
            let mode = $(this).val()


            // Show/hide appropriate editors
            if (mode === 'custom') {
                $(`#rich-editor-wrapper-${hotspotId}`).hide()
                $(`#custom-editor-wrapper-${hotspotId}`).show()
            } else {
                $(`#rich-editor-wrapper-${hotspotId}`).show()
                $(`#custom-editor-wrapper-${hotspotId}`).hide()
            }
        })

        return hotspot
    }

    createHotspot() {
        let that = this
        let query = { hotspot: { variant_id: this.pk } }

        $.ajax({
            url: '/hotspots.json',
            data: query,
            method: 'POST',
            headers: {
                'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content')
            },
            success: function (data, textStatus, jqXHR) {
                that.addHotspot(data)
                that.updateHotspot(data.id)
                that.updateThumbnailIndicators()
                that.centerActiveThumbnail()
            },
            error: function (xhr, status, error) {
                console.error('Failed to create hotspot:', xhr.responseText);
            }
        })
    }

    saveHotspots(completeHandler) {
        // Ensure any open rich text editors sync their contents to the model
        this.syncEditorsToModel()

        let unsavedHotspots = this.hotspots.length
        if (unsavedHotspots === 0) {
            completeHandler()
            return
        }

        for (let hotspot of this.hotspots) {
            let data = hotspot.data
            let pk = data.id

            let query = {
                hotspot: {
                    title: data.title,
                    path: data.path,
                    window: data.window,
                    text: data.text,
                    text_position: data.text_position,
                    video: data.video,
                    color: data.color,
                    content_opacity: data.content_opacity,
                    content_background: data.content_background,
                    content_foreground: data.content_foreground,
                    content_position: data.content_position,
                    content_mode: data.content_mode,
                    font_family: data.font_family,
                    image: data.image,
                    shadow: data.shadow
                }
            }

            $.ajax({
                method: 'PUT',
                url: `/hotspots/${pk}.json`,
                data: query,
                headers: {
                    'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content')
                },
                success: function () {
                    unsavedHotspots--

                    if (unsavedHotspots === 0) {
                        completeHandler()
                    }
                }
            })
        }
    }

    // Sync any visible rich text editors into their corresponding hidden inputs
    // and propagate changes into the current hotspot data model via existing handlers
    syncEditorsToModel() {
        const editors = document.querySelectorAll('.rich-text-editor')
        editors.forEach((editorEl) => {
            const hotspotIdAttr = editorEl.getAttribute('data-hotspot')
            if (!hotspotIdAttr) return
            const hotspotId = parseInt(hotspotIdAttr)
            const html = editorEl.innerHTML

            // Update corresponding hidden input if present (non-fatal if missing)
            const hidden = document.getElementById(`hotspot-text-${hotspotId}`)
            if (hidden) hidden.value = html

            // Update the hotspot model directly to avoid event-chain issues
            for (let hotspot of this.hotspots) {
                if (hotspot.data && hotspot.data.id == hotspotId) {
                    hotspot.data.text = html
                    break
                }
            }
            if (this.currentHotspot && this.currentHotspot.data && this.currentHotspot.data.id == hotspotId) {
                this.currentHotspot.data.text = html
            }
        })
    }

    deleteHotspotConfirm(pk) {
        this.deletePk = pk
        let ask = localStorage.getItem('hotspot-editor-delete-confirm-ask')
        if (ask === 'no') {
            this.deleteHotspot()
        } else {
            // Use Bootstrap 5 modal API or fallback to show/hide
            const modal = document.getElementById('hotspot-delete-confirm')
            if (modal && typeof modal.show === 'function') {
                modal.show()
            } else if (modal) {
                modal.style.display = 'block'
                modal.classList.add('show')
            }
        }
    }

    deleteHotspot() {
        // Use Bootstrap 5 modal API or fallback to show/hide
        const modal = document.getElementById('hotspot-delete-confirm')
        if (modal && typeof modal.hide === 'function') {
            modal.hide()
        } else if (modal) {
            modal.style.display = 'none'
            modal.classList.remove('show')
        }
        let pk = this.deletePk

        // delete on server
        this.closeForm()
        $(`.hotspot-editor-update[data-hotspot=${pk}]`).remove()
        let url = `/hotspots/${pk}`
        $.ajax({
            url: url,
            method: 'DELETE',
            headers: {
                'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content')
            },
            success: function (data) {
            }
        })

        let id = parseInt(pk)
        let remaining = []

        for (let hotspot of this.hotspots) {
            if (hotspot.data.id === id) {
                hotspot.remove()
            } else {
                remaining.push(hotspot)
            }
        }
        this.hotspots = remaining

        // Update thumbnail indicators after deletion
        this.updateThumbnailIndicators()
        this.centerActiveThumbnail()
    }

    imageUpload(file) {
        let s3 = new S3Upload(this)
        let filename = `hotspots/${file.name}`
        s3.uploadToVariant(this.uuid, [{ 'name': filename, 'payload': file }])

        var fr = new FileReader()
        let image = new Image()
        let that = this
        $('#hotspot-image-current span').text('Uploading...')
        fr.onload = function () {
            image.src = fr.result
            that.currentHotspot.imageObj = image
            that.currentHotspot.buildHTML()
        }
        fr.readAsDataURL(file)
    }

    s3UploadSuccess(filename) {
        this.currentHotspot.data['image'] = filename
        $('#hotspot-image-current span').text(filename)
        $('#hotspot-image-current').show()
    }

    s3UploadError(filename) {
        $('#hotspot-image-current span').text('Image upload failed')
        $('#hotspot-image-current').show()
    }
}

// Initialize HotspotEditor
let editor = new HotspotEditor();

// DEBUG
// editor.openEditor(1, 5128556)
